import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

export const useBookmarkContentCreate = () => {
  const createContentBookmark = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v3/content-bookmark/`, {
      body: JSON.stringify(payload),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, []);

  return useRestMutation(createContentBookmark);
};

export default useBookmarkContentCreate;
